import { initFooterScroll } from './footer-scroll.js';
import { ScrollContentProgressBar } from './ScrollContentProgressBar.js';
import { ScrollNavBar } from './ScrollNavBar.js';
import { ScrollOnePageSpy } from './ScrollOnePageSpy.js';

export function initScroll() {

    new ScrollNavBar();

    new ScrollOnePageSpy(
        "main > section[id]",
        'nav a[href^="#"]'
    );

    new ScrollContentProgressBar(

        '#progress_bar',
        'main'

    );

    initFooterScroll();

}